import { render, staticRenderFns } from "./IconStatusRevision.vue?vue&type=template&id=757407e6&scoped=true"
import script from "./IconStatusRevision.vue?vue&type=script&lang=js"
export * from "./IconStatusRevision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757407e6",
  null
  
)

export default component.exports